
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-details/[slug]",
      function () {
        return require("private-next-pages/product-details/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-details/[slug]"])
      });
    }
  